import { z } from 'zod';
import * as translator from '../../../../../utils/translator';

export type LogWeightFormValues = {
	weightKg: number;
	loggedAt?: string;
};

export const createLogWeightSchema = (language: string) =>
	z.object({
		weightKg: z
			.number({ invalid_type_error: translator.translate(language, 'my_account', 'CareProfile/LogWeight/InvalidWeight') })
			.min(30, translator.translate(language, 'my_account', 'CareProfile/LogWeight/InvalidWeight'))
			.max(300, translator.translate(language, 'my_account', 'CareProfile/LogWeight/InvalidWeight')),
		// Empty = "Today" (the default shown in the field); the server treats an
		// absent loggedAt as today, so an empty value is valid here.
		loggedAt: z
			.string()
			.regex(/^\d{4}-\d{2}-\d{2}$/, translator.translate(language, 'my_account', 'CareProfile/LogWeight/InvalidDate'))
			.refine((date) => {
				const d = new Date(date);
				return !isNaN(d.getTime()) && d <= new Date();
			}, {
				message: translator.translate(language, 'my_account', 'CareProfile/LogWeight/InvalidDate'),
			})
			.optional()
			.or(z.literal('')),
	});
